module.exports = "<div class=\"tooltip-title\">\n    <ng-content select=\"[tooltip-title]\"></ng-content>\n</div>\n<div\n    class=\"toltip-body\"\n    [style.visibility]=\"contentVisible ? 'visible' : 'hidden'\"\n>\n    <ng-content select=\"[tooltip-content]\"></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tooltip/tooltip.component.html
// module id = ./src/app/shared/components/tooltip/tooltip.component.html
// module chunks = main